module.exports = {
    'appName' : 'Vue-login',
    // 'apiUrl': (process.env.NODE_ENV !== 'production') ? (`http://dashboard-lokal.com/api-dashboard/`) : (`https://dashboard.suksesperkasaforestama.com/api-dashboard/`),
    'apiUrl': (process.env.NODE_ENV !== 'production') ? (`https://dashboard.suksesperkasaforestama.com/api-dashboard/`) : (`https://dashboard.suksesperkasaforestama.com/api-dashboard/`),
    'perpage' : 30,
    'key' : `fac6bf92dd997c72f16ad1b6bffa9bef`,
    'progam' : '001'
};